import { type MainMenuAdminProps } from '@framework/theme/admin/MainMenuAdmin.tsx';
import { Menu } from 'antd';
import styled from 'styled-components';

const StyledMenuWrapper = styled.nav`
  width: 100%;
  max-width: 100%;
  line-height: 54px; // altezza menu
  // inseriamo un margine negativo
  //per allineare il menu agli altri elementi della Header
  margin-left: -16px;
  margin-right: -16px;

  // rimuoviamo il fondo del menu
  .ant-menu-horizontal.ant-menu-dark {
    background-color: transparent;
    border-bottom-width: 0;
  }
  .ant-menu-item a,
  .ant-menu-submenu-title {
    /* color: #fff; */
    font-size: 18px;
    font-weight: 600;
    line-height: 54px;
    color: white;
    border-bottom-width: 0;
  }
  // inseriamo un bordo sotto le voci del
  // menu per evidenziare la selezione
  ul.ant-menu {
    .ant-menu-item,
    .ant-menu-submenu {
      &::after {
        content: '';
        display: block;
        height: 4px;
        background-color: transparent;
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        transition: all 0.1s ease-in-out;
      }
    }
    .ant-menu-item-selected,
    .ant-menu-item-selected:hover,
    .ant-menu-submenu-selected,
    .ant-menu-submenu-selected:hover {
      &::after {
        background-color: white;
      }
    }
  }
  // inseriamo un bordo ulteriore sotto le voci del menu
  // per evidenziare l'hover sull'elemento
  ul.ant-menu {
    .ant-menu-item,
    .ant-menu-submenu {
      &::before {
        content: '';
        display: block;
        height: 1px;
        background-color: transparent;
        position: absolute;
        bottom: 12px;
        left: 16px;
        right: 16px;
        transition: all 0.1s ease-in-out;
      }
      &:hover::before {
        background-color: white;
      }
    }
  }
`;
/** Utilizzato sia in Admin che in Backoffice */
export function MainMenuAdmin(props: MainMenuAdminProps) {
  return (
    <StyledMenuWrapper>
      <Menu
        theme="dark"
        style={{ flex: 'auto', minWidth: 0 }}
        mode="horizontal"
        triggerSubMenuAction="click"
        // rimosso forceSubMenuRender - fix A11Y Wave issue -> Broken ARIA menu
        forceSubMenuRender={false}
        {...props}
      />
    </StyledMenuWrapper>
  );
}
